import React from 'react';
import { useSelector } from 'react-redux';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import { Result } from '../ChatWidgetTroubleshootingToolResult';

type Props = {
  isXRay?: boolean;
};

export const useFBPageAgeRestrictions = (props: Props): Result => {
  const { isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  if (!result || isXRay) {
    return;
  }

  if (
    result.localTests.chatWidgetChannel !== 'facebook' ||
    !result.backendTests.facebookPageSettings ||
    result.backendTests.facebookPageSettings.ageRestrictions === 'Public'
  ) {
    return;
  }

  return {
    result: 'info',
    description: (
      <>
        Facebook Page has an age restriction. Your chat widget will only be
        visible to users who are signed into Facebook and meet the age
        restriction: {result.backendTests.facebookPageSettings.ageRestrictions}
        <a
          className="chat-widget-troubleshooting-tool-result__external-link"
          href={`https://www.facebook.com/${result.localTests.fbPageId}/settings/?section=age_restrictions&tab=settings`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Edit Page Settings
        </a>
      </>
    ),
  };
};
